import { makeAutoObservable, runInAction } from 'mobx'

import { newPasswordError } from '@/Ship/Helpers/passwordPolicy'
import { serverMessage } from '@/Ship/Helpers/serverError'

import { PatchUserTask } from '../Tasks/PatchUserTask'

/**
 * Вкладка «Змінити пароль» картки (`SPEC-005` §7.2): пароль задає супер
 * адміністратор будь-кому, решта — собі (право `update`).
 *
 * Розбіжність і закороткий пароль ловимо до запиту: підтвердження бек не
 * бачить зовсім (D-28), а коротке однаково повернув би 422.
 */
export class UserPasswordManager {
    isLoading = false
    error: string | null = null

    constructor() {
        makeAutoObservable(this)
    }

    /** `true` — пароль змінено, форму можна очищати. */
    async submit(uuid: string, password: string, confirmation: string): Promise<boolean> {
        const invalid = newPasswordError(password, confirmation)

        if (invalid !== null) {
            this.error = invalid
            return false
        }

        this.isLoading = true
        this.error = null

        try {
            await PatchUserTask(uuid, { plainPassword: password })

            return true
        } catch (error) {
            runInAction(() => {
                this.error = serverMessage(error, 'Не вдалося змінити пароль.')
            })

            return false
        } finally {
            runInAction(() => {
                this.isLoading = false
            })
        }
    }
}
